import { memo } from 'react';
import { useFrame } from '$shared/utils';
import styles from './n60-footer.module.css';
import { RichTextArea } from '../components/rich-text-area/rich-text-area.component';
import { MenuArea } from '../components/menu-area/menu-area.component';
import { NewsletterArea } from '../components/newsletter-area/newsletter-area.component';
import { IconArea } from '../components/icon-area/icon-area.component';
import { MetaArea } from '../components/meta-area/meta-area.component';
import { N80Trustpilot } from '../../n80-trustpilot/n80-trustpilot.component';

export const N60Footer = memo(() => {
    const { data: frame } = useFrame();

    const {
        contactText,
        menu,
        newsletterText,
        newsletterLink,
        additionalIcons,
        footerMeta,
        copyrights,
    } = frame?.footer || {};

    const showGrid = menu || contactText || newsletterText || newsletterLink;

    return (
        <footer className={styles.root}>
            {frame?.footer?.trustpilotWidgetSnippet && (
                <div className={styles.trustpilotWrapper}>
                    <N80Trustpilot markup={frame?.footer?.trustpilotWidgetSnippet} />
                </div>
            )}
            {showGrid && (
                <div className={styles.grid}>
                    <RichTextArea text={contactText} />
                    <div className={styles.divider} aria-hidden />
                    {menu && <MenuArea menu={menu} />}
                    {newsletterText || newsletterLink ? (
                        <NewsletterArea text={newsletterText} link={newsletterLink} />
                    ) : null}
                    <IconArea
                        paymentIcons={frame?.ecommerce?.paymentIcons}
                        additionalIcons={additionalIcons}
                        marketSelector
                    />
                </div>
            )}
            <MetaArea
                copyRightNotice={copyrights}
                footerMeta={footerMeta}
                soMeLinks={frame?.footer?.socialLinks}
            />
        </footer>
    );
});

export default N60Footer;
